import React, { useRef } from 'react';
import useStyles from './Style';

import { useSnackbar } from 'notistack';
import { useMutation } from '@apollo/react-hooks';
import { Button, Grid, Dialog, DialogTitle, DialogContent, Typography, InputLabel, TextField } from '@material-ui/core';
import { EXECUTE_SCENARIO, UPDATE_SEQUENCE, UPDATE_SCENARIO, UPDATE_TRANSACTIONID } from '../graphQL/queries';
import {
  getSimulationFields,
  getInputField,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  formatString
} from '../../utils/helpers';
import { Form } from '../../components/Form';
import { Loading } from '../../Loading';

import JsonEditor from '../../components/JsonEditor';
import { PlayCircle } from '@jda/lui-common-icon-library';
import { Done } from '@material-ui/icons';

import ArrowChevronDown from '@jda/lui-common-icon-library/ui/ArrowChevronDown';

import moment from 'moment';
const ExecuteScenario = (props: any) => {
  const [executeScenario] = useMutation(EXECUTE_SCENARIO);
  const [updateSequence] = useMutation(UPDATE_SEQUENCE);
  const [updateScenario] = useMutation(UPDATE_SCENARIO);
  const [updateTransactionIds] = useMutation(UPDATE_TRANSACTIONID);
  const { enqueueSnackbar } = useSnackbar();
  const customerCode = 'BYManagedTestCustomer';
  const providerCode = 'BYManagedTestProvider';
  const {
    stepExecuteModalOpen,
    setFormField,
    rowData,
    workflowList,
    participant,
    activeInex,
    fields,
    simulationTestData,
    step,
    executionData,
    getExecutionData,
    testScenarioExecutionSeq,
    loadingTestData,
    loadingExecutionData
  } = props;

  const defaultStates = {
    requestJsonEditor: false,
    transactionId1: '',
    transactionId2: ''
  };

  const [{ requestJsonEditor, transactionId1, transactionId2 }, setField] = React.useState({ ...defaultStates });
  const classes = useStyles();

  const isDisabled = (sequence: any) => {
    const workflow = workflowList.data?.workflow?.content?.filter(
      (item: any) => item.workflowName === sequence?.serviceNm
    );
    const operation = workflow?.[0]?.operations?.filter(
      (operatioItem: any) => operatioItem.operationName === sequence?.operation
    );
    return operation?.[0]?.initiator === participant?.participantType;
  };

  const isCompleted = (step: any) => {
    const testScenarioExecutionSeq = executionData?.getExecutionData?.testScenarioExecutionSeq;
    if (step?.sequence === 1) return true;
    return step?.sequence > 1 && testScenarioExecutionSeq?.[step?.sequence - 2]?.status === 'VERIFIED';
  };

  const handleUpdateScenario = () => {
    updateScenario({
      variables: {
        testScenarioNm: rowData?.testScenarioName,
        participantCode: participant?.participantCode,
        status: 'VERIFIED',
        // status: testScenarioExecutionSeq?.[0]?.status,
        serviceNm: executionData?.getExecutionData?.serviceNm
      }
    })
      .then((res: any) => {
        enqueueSnackbar('Scenario Certified Successfully !!', {
          variant: 'success',
          preventDuplicate: true
        });
        setFormField((prevState: any) => ({
          ...prevState,
          stepExecuteModalOpen: !stepExecuteModalOpen,
          testScenarioExecutionSeq: [],
          activeInex: '',
          fields: [],
          step: ''
        }));
      })
      .catch((e: any) => {
        enqueueSnackbar('Execution Failed !!', {
          variant: 'error',
          preventDuplicate: true
        });
      });
  };

  const handleVerify = () => {
    updateSequence({
      variables: {
        testScenarioNm: step?.testScenarioName,
        participantCode: participant?.participantCode,
        testSequence: step?.sequence,
        status: 'VERIFIED',
        // status: testScenarioExecutionSeq?.[0]?.status,
        serviceNm: step?.serviceNm
      }
    })
      .then((res: any) => {
        enqueueSnackbar('Sequence Validated Successfully !!', {
          variant: 'success',
          preventDuplicate: true
        });
        getExecutionData({
          variables: {
            participantCode: participant.participantCode,
            testScenarioNm: step.testScenarioName,
            serviceNm: step.serviceNm
          }
        });
      })
      .catch((e: any) => {
        enqueueSnackbar('Execution Failed !!', {
          variant: 'error',
          preventDuplicate: true
        });
      });
  };
  const handleSimulationSubmit = (formData: any) => {
    const workflow = workflowList.data?.workflow?.content?.filter((item: any) => item.workflowName === step?.serviceNm);
    const operation = workflow?.[0]?.operations?.filter(
      (operatioItem: any) => operatioItem.operationName === step?.operation
    );
    const testData = simulationTestData?.simulatedData?.filter(
      (item: any) => item?.testDataName === step?.testDataName
    );
    const inputFields = getInputField(fields, formData, formatString(testData[0]?.input));
    const payload = {
      apiHeader: {
        companyCode: 'BlueYonder',
        contractedCompanyCode: 'BYN',
        customerCode: [customerCode],
        messageID: Math.random()
          .toString(36)
          .substr(2, 5),
        providerCode: participant?.participantCode,
        timestamp: moment(new Date()).format('YYYY-MM-DDTHH:mm:ss[Z]')
      },
      ...inputFields
    };

    executeScenario({
      variables: {
        participantCode: participant?.participantCode,
        testScenarioNm: rowData.testScenarioName,
        operation: operation?.[0]?.operationCode,
        testSequence: step?.sequence,
        serviceNm: workflow?.[0]?.workflowCode,
        input: payload
      }
    })
      .then((res: any) => {
        enqueueSnackbar('Execution Validated Successfully !!', {
          variant: 'success',
          preventDuplicate: true
        });
        getExecutionData({
          variables: {
            participantCode: participant.participantCode,
            testScenarioNm: step.testScenarioName,
            serviceNm: step.serviceNm
          }
        });
      })
      .catch((e: any) => {
        enqueueSnackbar('Execution Failed !!', {
          variant: 'error',
          preventDuplicate: true
        });
      });
  };

  const setDate = (value: any, key: any) => {
    if (fields.length > 0) {
      fields.map((item: any) => {
        if (item.key === key) item.defaultValue = value;
      });
      setFormField((prevState: any) => ({ ...prevState, fields }));
    }
  };
  const showStepGrid = (step: any, index: any) => {
    const testData = simulationTestData?.simulatedData?.filter(
      (item: any) => item?.testDataName === step?.testDataName
    );
    const fields = getSimulationFields(testData?.[0]?.configSpec);
    const testScenarioExecutionSeq = executionData?.getExecutionData?.testScenarioExecutionSeq?.filter(
      (item: any) => item.operation === step?.operation
    );
    setFormField((prevState: any) => ({
      ...prevState,
      fields,
      activeInex: index,
      step,
      testScenarioExecutionSeq
    }));
  };
  const jsonSpecEditorRef = useRef<any>();
  const jsonOutputEditorRef = useRef<any>();

  const setRequestEditorRef = (instance: any) => {
    if (instance) {
      jsonSpecEditorRef.current = instance.jsonEditor;
    } else {
      jsonSpecEditorRef.current = null;
    }
  };

  const setResponseEditorRef = (instance: any) => {
    if (instance) {
      jsonOutputEditorRef.current = instance.jsonEditor;
    } else {
      jsonOutputEditorRef.current = null;
    }
  };

  const handleSendRequest = () => {
    const workflow = workflowList.data?.workflow?.content?.filter((item: any) => item.workflowName === step?.serviceNm);
    const operation = workflow?.[0]?.operations?.filter(
      (operatioItem: any) => operatioItem.operationName === step?.operation
    );
    executeScenario({
      variables: {
        participantCode: participant?.participantCode,
        testScenarioNm: rowData.testScenarioName,
        operation: operation?.[0]?.operationCode,
        testSequence: step?.sequence,
        serviceNm: workflow?.[0]?.workflowCode,
        input: formatString(jsonSpecEditorRef.current?.getText())
      }
    })
      .then((res: any) => {
        enqueueSnackbar('Request Execution Successfully !!', {
          variant: 'success',
          preventDuplicate: true
        });
        getExecutionData({
          variables: {
            participantCode: participant.participantCode,
            testScenarioNm: step.testScenarioName,
            serviceNm: step.serviceNm
          }
        });
      })
      .catch((e: any) => {
        enqueueSnackbar('Execution Failed !!', {
          variant: 'error',
          preventDuplicate: true
        });
      });
  };

  const handleTransactionId = () => {
    const paylaod = {} as any;
    if (transactionId1 !== '') paylaod['transactionId1'] = transactionId1;
    if (transactionId2 !== '') paylaod['transactionId2'] = transactionId2;
    updateTransactionIds({
      variables: {
        testScenarioNm: rowData?.testScenarioName,
        participantCode: participant?.participantCode,
        serviceNm: rowData?.serviceNm,
        ...paylaod
      }
    })
      .then((res: any) => {
        enqueueSnackbar('Scenario Mapped Successfully !!', {
          variant: 'success',
          preventDuplicate: true
        });
        getExecutionData({
          variables: {
            participantCode: participant.participantCode,
            testScenarioNm: step.testScenarioName,
            serviceNm: step.serviceNm
          }
        });
        setField(prevState => ({ ...prevState, transactionId1: '', transactionId2: '' }));
      })
      .catch((e: any) => {
        enqueueSnackbar('Execution Failed !!', {
          variant: 'error',
          preventDuplicate: true
        });
      });
  };

  const handleFieldChange = (e: any) => {
    const { name, value } = e?.target;
    setField(prevState => ({ ...prevState, [name]: value }));
  };

  const handleDisableVerify = () => {
    let disable = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    executionData?.getExecutionData?.testScenarioExecutionSeq?.map((seq: any) => {
      if (seq.status === 'VERIFIED') disable = false;
    });
    if (rowData?.testStepSequence?.length !== executionData?.getExecutionData?.testScenarioExecutionSeq?.length)
      disable = true;
    return disable;
  };

  const getIcon = (step: any) => {
    const status = executionData?.getExecutionData?.testScenarioExecutionSeq?.map((test: any) => {
      if (test?.operation === step?.operation) return test;
    });
    switch (status?.[0]?.status) {
      case 'VERIFIED':
        return (
          <span style={{ color: 'rgb(40 195 95)' }}>
            {step.testStepName}
            <Done style={{ position: 'absolute', right: '10px' }} />
          </span>
        );
      case 'SUCCESSFUL':
        return <span style={{ color: 'rgb(40 195 95)' }}>{step.testStepName}</span>;
      default:
        return <span>{step.testStepName}</span>;
    }
  };

  const handleRefresh = (step: any) => {
    getExecutionData({
      variables: {
        participantCode: participant?.participantCode,
        testScenarioNm: step.testScenarioName,
        serviceNm: step.serviceNm
      }
    });
    showStepGrid(rowData?.testStepSequence?.[0], 0);
  };

  return (
    <Dialog
      maxWidth="xl"
      fullWidth
      open={stepExecuteModalOpen}
      onClose={() =>
        setFormField((prevState: any) => ({
          ...prevState,
          stepExecuteModalOpen: !stepExecuteModalOpen,
          rowData: { testScenarioName: '', testStepSequence: [] },
          testScenarioExecutionSeq: [],
          fields: []
        }))
      }
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      id="custom-grid-dialog"
    >
      <DialogTitle id="customgrid-dialog-title">
        Execute Test Cases-<b> {rowData?.testScenarioName}</b>
        <Grid container className={classes.execution}>
          <Grid item xs={2} spacing={1}>
            Participant code: {executionData?.getExecutionData?.participantCode}
          </Grid>
          <Grid item xs={2} spacing={1}>
            Status:
            <span
              style={{
                color:
                  executionData?.getExecutionData?.status === 'SUCCESSFUL' ||
                  executionData?.getExecutionData?.status === 'VERIFIED'
                    ? 'rgb(122 213 178)'
                    : ''
              }}
            >
              {executionData?.getExecutionData?.status}
            </span>
          </Grid>
          <Grid item xs={3} spacing={1}>
            Service Name: {executionData?.getExecutionData?.serviceNm}
          </Grid>
          <Grid item xs={2} spacing={1}>
            Transaction Id1: {executionData?.getExecutionData?.transactionId1}
          </Grid>
          <Grid item xs={3} spacing={1}>
            <Button
              variant="outlined"
              onClick={handleUpdateScenario}
              data-id="certify-execution"
              id="certify-execution"
              color="primary"
              disabled={handleDisableVerify()}
              style={{ margin: '0 5px' }}
            >
              Verify Sceanrio
            </Button>
            <Button
              variant="outlined"
              onClick={() => handleRefresh(step)}
              data-id="certify-execution"
              id="certify-execution"
              color="primary"
              disabled={step === ''}
              style={{ margin: '0 5px' }}
              title="Retrieve asynchronous response from the Provider/Customer"
            >
              Refresh
            </Button>
            <Button
              variant="outlined"
              onClick={() =>
                setFormField((prevState: any) => ({
                  ...prevState,
                  stepExecuteModalOpen: !stepExecuteModalOpen,
                  testScenarioExecutionSeq: [],
                  activeInex: '',
                  fields: [],
                  step: ''
                }))
              }
              data-id="cancel-execution"
              id="cancel-execution"
              color="primary"
              style={{ margin: '0 5px' }}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent>
        {loadingTestData || loadingExecutionData ? (
          <Loading />
        ) : (
          <Grid container className={classes.executeStep} spacing={2}>
            <Grid item xs={2}>
              <h2>Test Steps</h2>
              <div className={classes.timeline}>
                {rowData &&
                  rowData?.testStepSequence?.length > 0 &&
                  rowData?.testStepSequence?.map((step: any, index: any) => (
                    <div
                      className={`${classes.timelinePost} ${isCompleted(step) ? '' : 'disabled'}`}
                      onClick={() => showStepGrid(step, index)}
                    >
                      <Grid container>
                        <Grid item xs={2} style={{ zIndex: 1 }}>
                          <PlayCircle
                            fontSize="large"
                            data-id="execute-operation"
                            className={`${classes.timelineChip} ${activeInex === index ? 'active' : ''}`}
                          />
                        </Grid>
                        <Grid item xs={10} className={classes.requestContent}>
                          {getIcon(step)}
                        </Grid>
                      </Grid>
                    </div>
                  ))}
              </div>
            </Grid>
            <Grid item xs={5} className={classes.formFields}>
              {isDisabled(step) &&
                step?.sequence === 1 &&
                (!testScenarioExecutionSeq || testScenarioExecutionSeq?.length === 0) && (
                  <Grid container>
                    <Grid item xs={6}>
                      <InputLabel id="transactionId1-label">Transaction ID 1</InputLabel>
                      <TextField
                        data-id="transactionId1-input"
                        id="transactionId1"
                        name="transactionId1"
                        value={transactionId1}
                        onChange={handleFieldChange}
                        style={{ width: '80%' }}
                        required
                      ></TextField>
                    </Grid>
                    <Grid item xs={6}>
                      <InputLabel id="transactionId1-label">Transaction ID 2</InputLabel>
                      <TextField
                        data-id="transactionId2-input"
                        id="transactionId2"
                        name="transactionId2"
                        value={transactionId2}
                        onChange={handleFieldChange}
                        style={{ width: '80%' }}
                        required
                      ></TextField>
                    </Grid>
                    <Button
                      variant="outlined"
                      onClick={handleTransactionId}
                      data-id="certify-execution"
                      id="certify-execution"
                      color="primary"
                      style={{ float: 'right', margin: '10px 5px' }}
                    >
                      Submit
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() =>
                        setFormField((prevState: any) => ({
                          ...prevState,
                          stepExecuteModalOpen: !stepExecuteModalOpen,
                          testScenarioExecutionSeq: [],
                          activeInex: '',
                          fields: [],
                          step: ''
                        }))
                      }
                      data-id="cancel-execution"
                      id="cancel-execution"
                      color="primary"
                      style={{ float: 'right', margin: '10px 5px' }}
                    >
                      Cancel
                    </Button>
                  </Grid>
                )}
              {fields?.length > 0 && !isDisabled(step) && (
                <Form
                  className={classes.root}
                  dataConfig={fields}
                  handleDialogSubmit={handleSimulationSubmit}
                  submitlabel="Fetch Request"
                  setDate={setDate}
                  disabled={isDisabled(step)}
                />
              )}
              {step && (
                <>
                  {testScenarioExecutionSeq?.length > 0 && (
                    <Accordion
                      elevation={0}
                      expanded={testScenarioExecutionSeq?.[0]?.requestLog !== ''}
                      onChange={(e, expanded) =>
                        setField((prevState: any) => ({ ...prevState, requestJsonEditor: !requestJsonEditor }))
                      }
                      // expanded={!requestJsonEditor}
                    >
                      <AccordionSummary
                        expandIcon={<ArrowChevronDown color="inherit" />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography>{!isDisabled(step) ? 'Edit The' : ''} Request</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid item xs={12}>
                          {testScenarioExecutionSeq?.[0]?.requestLog && (
                            <>
                              {!isDisabled(step) && (
                                <Button
                                  variant="outlined"
                                  onClick={handleSendRequest}
                                  data-id="certify-execution"
                                  id="certify-execution"
                                  color="primary"
                                  style={{ float: 'right' }}
                                >
                                  Send Request
                                </Button>
                              )}
                              <JsonEditor
                                data-id="transform-spec-editor"
                                setRef={setRequestEditorRef}
                                data={formatString(testScenarioExecutionSeq?.[0]?.requestLog)}
                                view={false}
                                mode="code"
                                id={'JsonEditorSpec'}
                                allowedModes={['code', 'tree']}
                                theme="ace/theme/github"
                                htmlElementProps={{
                                  style: {
                                    height: '60vh',
                                    width: '100%'
                                  }
                                }}
                              />
                            </>
                          )}
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  )}
                  {testScenarioExecutionSeq?.length === 0 &&
                    (fields.length === 0 || (isDisabled(step) && step?.sequence !== 1)) && <h2>No Message Recieved</h2>}
                </>
              )}
            </Grid>
            <Grid item xs={5} className={classes.formFields}>
              {step && testScenarioExecutionSeq?.length > 0 && (
                <>
                  <h2>Response Status</h2>
                  <Grid container>
                    <Grid item xs={6}>
                      Response HTTP Status: {testScenarioExecutionSeq?.[0]?.responseHttpStatus}
                    </Grid>
                    <Grid item xs={6}>
                      Status: {testScenarioExecutionSeq?.[0]?.status}
                    </Grid>
                    <Accordion
                      elevation={0}
                      expanded={testScenarioExecutionSeq?.[0]?.responseLog !== ''}
                      onChange={(e: any, expanded: any) =>
                        setField((prevState: any) => ({ ...prevState, requestJsonEditor: !requestJsonEditor }))
                      }
                      //   expanded={requestJsonEditor}
                    >
                      <AccordionSummary
                        expandIcon={<ArrowChevronDown color="inherit" />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography>Response Received</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid item xs={12} spacing={2}>
                          {testScenarioExecutionSeq?.[0]?.responseLog && (
                            <>
                              <Button
                                variant="outlined"
                                onClick={handleVerify}
                                data-id="certify-execution"
                                id="certify-execution"
                                color="primary"
                                style={{ float: 'right' }}
                              >
                                Verify The Step
                              </Button>
                              <JsonEditor
                                data-id="transform-spec-editor"
                                setRef={setResponseEditorRef}
                                data={formatString(testScenarioExecutionSeq?.[0]?.responseLog)}
                                view={false}
                                mode="code"
                                id={'JsonEditorSpec'}
                                allowedModes={['code', 'tree']}
                                theme="ace/theme/github"
                                htmlElementProps={{
                                  style: {
                                    width: '30vw'
                                  }
                                }}
                              />
                            </>
                          )}
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ExecuteScenario;
